export default __webpack_public_path__ + "static/media/racelog_purple.f6526b11.png";